module.exports = __webpack_public_path__ + "static/media/attack-doubled.563a8810.png";